import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react'

import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, findCode, getAction, printVariable } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { setSchola } from '@redux/actions/scholaAction'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'

// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import moment from 'moment'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import ManagerSmstPart from './manager-smst.part'
import ManagerNoticePartMod from '@pages/manager/manager-notice.part.mod'
import TransDialog from '@components/TransDialog'
import ConfirmDialog from '@components/ConfirmDialog'
import { Link } from 'react-router-dom'
import ManagerNoticePartView from '@pages/manager/manager-notice.part.view'
import useAlert from '@hooks/useAlert'
import { useParams } from 'react-router-dom'
import Hashids from 'hashids'
import { useLocation } from 'react-router-dom'
import CheckCircleOutlineOutlined  from '@mui/icons-material/CheckCircleOutlineOutlined'
import SquareIcon from '@mui/icons-material/Square';
import { BarChart } from '@mui/x-charts/BarChart';
import { LineCart, LineChart} from '@mui/x-charts/LineChart';

const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`


const ManagerDashboardPage = () => {
  console.log('ManagerDashboardPage rendering...')

  const [dataList, set_dataList] = useState([])

  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const modHandler = useState(false)
  const viewHandler = useState(false)
  const [modOpen, set_modOpen] = useState(false)
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const location = useLocation()
  const curLocationRef = useRef(location)
  const grades = [0, 1,2,3,4,5,6,7]
  const sums = [
    {field:'gubun', name:'구분' },
    {field:'lcnt', name:'프로그램수' },
    {field:'lcnt', name:'반수' },
    {field:'tcnt', name:'강사수' },
    {field:'scnt', name:'학생수' },
  ]
  const [dashboard, set_dashboard] = useState({})
  const [dashboards, set_dashboards] = useState([])
  const [smsts, set_smsts] = useState([])
  const [smst, set_smst] = useState({})
  const [barData, set_barData] = useState([])
  const fetchDashboard = async() => {
    const url = `/dashboard/${schola.id}`
    
    openIndicator()
    const resp = await WebService.get(url, )
    console.log('resp=>', resp)
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage) 
      return
    }
    return JSON.parse(resp.repMessage)
  }

  const onLoad = async() => {
    const info = await fetchDashboard()
    const dashboards = info.dashboards
    const smsts = info.smsts

    console.log('smsts=>', smsts)
    if(dashboards.length > 0 ) {
      dashboards.forEach(d => {
        console.log('d=>', d)
      })
      set_dashboard(dashboards[0])
      set_smst(smsts[0])
      
      const copied = JSON.parse(JSON.stringify(smsts))
      copied.sort((a, b) => a.id - b.id)
      const barData = []
      copied.forEach((item,idx) => {
        const gisu = `${item.year}-${item.gisu}` 
        const inwon  = dashboards.find(r => r.smstId === item.id)?.s_dup
        const inwon2  = dashboards.find(r => r.smstId === item.id)?.s_uni
        barData.push({
          gisu: gisu,
          inwon: +inwon,
          inwon2: +inwon2,
        })
      })
      console.log('barData=>', barData)
      set_barData(barData)

      set_smsts(smsts)
      set_dashboards(dashboards)
    }
  }

  useEffect(() => {
    if (curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
    }
  }, [location])

  useEffect(() => {
    onLoad()
  }, [])

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div style={{ paddingRight: 10, width:'100%', }}>
          <Grid container spacing={0} style={{display:'flex', alignItems:'center'}}>
            <Grid item xs style={{}}>
              <h1>수강 현황</h1>
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel id='topic' size='small' sx={{fontSize:'0.9em'}}>
                  기수
                </InputLabel>
                <Select
                  labelId='topic'
                  label='기수'
                  size='small'
                  sx={{fontSize:'0.9em'}}
                  value={smst}
                  onChange={(e) => {
                    set_smst(e.target.value)
                    const found = dashboards.find(r => r.smstId === e.target.value.id)
                    if(found) {
                      set_dashboard(found)
                    }
                  }}>
                  {smsts.map((s, index) => {
                    return (
                      <MenuItem key={index} value={s}>
                        {s.year}-{s.gisu}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}></Grid>
          </Grid>
        </div>
      </div>
      <div style={{ paddingTop: 10 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LineChart
            dataset={barData}
            xAxis={[{ scaleType:'band', dataKey: 'gisu', label:'기수'}]}
            series={[
                { dataKey: 'inwon', label:'수강인원' },
            ]}
            width={400}
            height={200}
          />

          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{display:'flex', fontWeight:'bold', alignItems:'center', }}
            >
              <SquareIcon size='small' style={{color:'#616161'}}/>&nbsp;수강 현황: 수강접수/출석부 인원 기준
            </Typography>
          </Grid>
          <Grid item xs={12}>
              <Grid container spacing={2}> 
                {
                  grades.map( (item, index) => (
                    <Grid item xs={1.5} key={index}>
                      <Typography variant='body2'>
                      {
                        item == 0 ? (
                            '구분'
                        ) : item == 7 ? (
                            '합계'
                        ) : (
                            item + '학년'
                        ) 
                      }
                      </Typography>
                    </Grid>
                  ))
                }
              </Grid>
          </Grid>
          <Grid item xs={12}><Divider/></Grid> 
          <Grid item xs={12}>
              <Grid container spacing={2}> 
                {
                  grades.map( (item, index) => (
                    <Grid item xs={1.5} key={index}>
                      <Typography variant='body2'>
                      {
                        item == 0 ? (
                            '학생수(A)'
                        ) : item == 7 ? (
                            dashboard[`s_tot`]
                        ) : (
                            dashboard[`s_tot_${item}`]
                        ) 
                      }

                      </Typography>
                    </Grid>
                  ))
                }
              </Grid>
          </Grid>
          <Grid item xs={12}>
              <Grid container spacing={2}> 
                {
                  grades.map( (item, index) => (
                    <Grid item xs={1.5} key={index}>
                      <Typography variant='body2'>
                      {
                        item == 0 ? (
                            '중복수강생수(B)'
                        ) : item == 7 ? (
                            dashboard[`s_dup`]
                        ) : (
                            dashboard[`s_dup_${item}`]
                        ) 
                      }

                      </Typography>
                    </Grid>
                  ))
                }
              </Grid>
          </Grid>
          <Grid item xs={12}>
              <Grid container spacing={2}> 
                {
                  grades.map( (item, index) => (
                    <Grid item xs={1.5} key={index}>
                      <Typography variant='body2'>
                      {
                        item == 0 ? (
                            '순수강생수(C)'
                        ) : item == 7 ? (
                            dashboard[`s_uni`]
                        ) : (
                            dashboard[`s_uni_${item}`]
                        ) 
                      }

                      </Typography>
                    </Grid>
                  ))
                }
              </Grid>
          </Grid>
          <Grid item xs={12}>
              <Grid container spacing={2}> 
                {
                  grades.map( (item, index) => (
                    <Grid item xs={1.5} key={index}>
                      <Typography variant='body2'>
                      {
                        item == 0 ? (
                            '비율(B/A)'
                        ) : item == 7 ? (
                            (dashboard[`s_percent`]  ??  '') + '%'
                        ) : (
                            (dashboard[`s_percent_${item}`]  ?? '') + '%'
                        ) 
                      }
                      </Typography>
                    </Grid>
                  ))
                }
              </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography style={{fontWeight:'bold', marginTop:10, display:'flex', alignItems:'center'}}
            >
              <SquareIcon size='small' style={{color:'#616161'}} />&nbsp;운영(중/할) 현황
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              {
                sums.map((item, index) => (
                  <Grid item xs={2} key={index}>
                    <Typography variant='body2'>
                      {item.name}
                    </Typography>
                  </Grid>
                ))
              }
            </Grid>
          </Grid>
          <Grid item xs={12}><Divider/></Grid>
          <Grid item xs={12}>
            <Grid container>
              {
                sums.map((item, index) => (
                  <Grid item xs={2} key={index}>
                    <Typography variant='body2'>
                      {
                        item.field=== 'gubun'  ?  
                          '운영현황'
                         : 
                          dashboard[item.field]
                      }
                    </Typography>
                  </Grid>
                ))
              }
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{fontWeight:'bold', marginTop:10, display:'flex', alignItems:'center'}}
            >
             <SquareIcon size='small' style={{color:'#616161'}} />&nbsp;폐강 현황
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              {
                dashboard.closedLectures?.map((item, index) => (
                  <Grid item xs={12} key={index}>
                    <Typography>
                      {item.title}
                    </Typography>
                  </Grid>
                ))
              }
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div>
        {renderSnackbar()}
        {renderIndicator()}
        {renderAlert()}

      </div>
    </div>
  )
}

export default ManagerDashboardPage
